import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  loadModuleFiles,
  LoadModuleFilesParams,
} from '~src/services/api/modules';
import { DbModuleFile } from '~src/types/db';
import { useProjectId } from '../useProjectId';

type UseModuleFilesParams = Omit<LoadModuleFilesParams, 'projectId'>;

export const useModuleFiles = (
  loadModuleFilesParams: UseModuleFilesParams,
  queryConfig: QueryConfig<DbModuleFile[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const moduleFilesQuery = useQuery<DbModuleFile[], AxiosError>(
    [
      'moduleFiles',
      {
        projectId: String(projectId),
        ...loadModuleFilesParams,
      },
    ],
    loadModuleFiles,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return moduleFilesQuery;
};
